module.exports = __webpack_public_path__ + "static/dp-logo-200w-49830d802b9e8742e4ba4930e4c75315.png";